import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import OrderTracking from './subcomponents/OrderTracking';

interface IOrderDetailsDialogProps {
	orderId: string;
	hideDialog: () => void;
}

const OrderDetailsDialog = ({ orderId, hideDialog }: IOrderDetailsDialogProps) => {
	return (
		<CustomDialog
			isOpen={true}
			hideDialog={hideDialog}
			header={translate('purchase.history.device.details')}
			dialogBody={<OrderTracking orderId={orderId} />}
		/>
	);
};

export default OrderDetailsDialog;
